import styled from 'styled-components'

export const Container = styled.div`

    .floatingSummary {
        text-align: left;
        padding: 1rem 0.75rem;
        background: rgba(255, 255, 255, 0.8);
        z-index: 2;
        top: 8%;
        left: calc(min(25%, 380px) + 10px);
        position: absolute;
        font-size: 0.8rem;
        font-weight: 300;
        max-width: 200px;
        @media screen and (max-width: 772px) {
          display: grid;
          grid-template-columns: 1fr 0.78fr;
          //position: relative;
          top: 0;
          max-width: 100%;
          width: 100%;
          left: 0;
          background: #fff;
          height: 55px;
          box-sizing: border-box;
        }
        p {
           
            padding-top: 0;
            padding-bottom: 0;
        }
        &__HideDesktop {
            @media screen and (min-width: 773px) {
            display: none;
            }
        }
        &__Model {
          font-size: 1.3rem;
          margin-bottom: 0.5rem; 
            &Wrapper {
                margin-bottom: 0.3rem;
            }
            &__Name {
                font-weight: bold;
                text-transform: uppercase;
            }
            &_Description {
                &Wrapper {
                    &_Hidden {
                        display: none;
                    }
                }
                font-size: 0.7rem;
                margin-bottom: 0.7rem;
                b{
                  font-weight: 700;
                }
                a{
                  color: inherit;
                }
            }
        }
        &__Price {
          margin-top: 1rem;
          margin-bottom: 0;
          font-size: 1.4rem;

            &Wrapper {
                margin-bottom: 0.3rem;
                @media screen and (max-width: 772px) {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-content: flex-end;
                    align-items: flex-end;
                } 
            }
                
          
            &_Currency {
                font-size: 0.9rem;
            }
            &_Price {
                font-weight: bold;
                text-transform: uppercase;
            }
            &_Description {
                font-size: 0.7rem;
                font-weight: 400;
                margin-top: 0;
            }
        }
        &__Details {
            @media screen and (max-width: 772px) {
                display: none;
            }
            &Title {
                margin-top: 0.7rem;
                margin-bottom: 0.2rem;
                font-weight: bold;
            }
        }
    }

    .ModalOverlay {
        position: fixed;
        background: rgba(239, 239, 239, 1);
        height: 100%;
        width: 100%;
        overflow-y: auto;
        z-index: 100;

        .ModalOverlay__inner {
            padding: 25px;
        }
    }

    transform: translate3d(0, 0, 0);
    position: fixed;

    &,
    .contentWrapper {
        /* height: 100%; */
        height: calc(var(--vh) * 100 - 54px);
        width: 100%;
        display: flex;
        flex-direction: row;

        &.disabled {
            transform: translate3d(0, 0, 0);
            position: fixed;
            pointer-events: none;
            overflow: hidden;
        }

        iframe,
        .button,
        .panel,
        .panel * {
            pointer-events: all;
        }

        .loadingOveflow {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: #ebebeb;
            background-image: url(${require('./tempBackground.jpg')});
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;

            .spinner {
                animation: rotate 2s linear infinite;
                z-index: 2;
                position: absolute;
                top: 50%;
                left: 50%;
                margin: -65px 0 0 -25px;
                width: 40px;
                height: 40px;

                & .path {
                    stroke: #eee;
                    stroke-linecap: round;
                    animation: dash 1.5s ease-in-out infinite;
                }
            }

            @keyframes rotate {
                100% {
                    transform: rotate(360deg);
                }
            }

            @keyframes dash {
                0% {
                    stroke-dasharray: 1, 150;
                    stroke-dashoffset: 0;
                }
                50% {
                    stroke-dasharray: 90, 150;
                    stroke-dashoffset: -35;
                }
                100% {
                    stroke-dasharray: 90, 150;
                    stroke-dashoffset: -124;
                }
            }

            .loadingMessage {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-weight: bold;
                color: #eee;
                @media only screen and (max-width: 772px) {
                    font-size: 12px;
                }
            }
        }
    }

    * {
        transition: all 0.2s ease-in-out;
    }

    &.isLoaded {
        .centalPanel {
            opacity: 1;
            pointer-events: 'all';
        }
    }

    &.isLoading {
        .centalPanel {
            opacity: 0;
            transition: all 0.5s ease-in-out;
            pointer-events: 'none';
        }
    }

    .react-hint {
        font-size: 10px;
        left: 0 !important;
        width: 300px;
        @media (max-width: 400px) {
            max-width: 100vw;
        }
        /* max-width: 100%; */

        filter: drop-shadow(0px 4px 25px rgba(0, 0, 0, 0.25));

        &:after {
            display: none;
        }

        .react-hint__title {
            font-weight: bold;
            margin-bottom: 0.8em;
        }

        .react-hint__content-flex {
            display: flex;
            align-items: flex-start;
        }

        .react-hint__content-img {
            flex-grow: 0;
            flex-shrink: 0;
            width: 30%;
            height: auto;
            aspect-ratio: 1;
            display: block;
            margin-right: 10px;
            background-size: cover;
        }

        .react-hint__content-text {

        }

        .react-hint__content {
            background: #8A795D;
            color: #eaeaea;
            /* background-color: rgba(130, 130, 130, 0.6);
            color: #000; */
            border-radius: 0;
            font-weight: 300;
            line-height: 1.15;
            padding: 10px;
            /* max-width: 50vw; */
            /* max-height: vw; */
            overflow: auto;
        }
    }

    .check {
        cursor: pointer;
        position: relative;
        margin: 0 4px;
        width: 18px;
        height: 18px;
        -webkit-tap-highlight-color: transparent;
        transform: translate3d(0, 0, 0);

        &:before {
            content: '';
            position: absolute;
            top: -15px;
            left: -15px;
            width: 48px;
            height: 48px;
            border-radius: 50%;
            background: rgba(34, 50, 84, 0.03);
            opacity: 0;
            transition: opacity 0.2s ease;
        }

        svg {
            position: relative;
            z-index: 1;
            fill: none;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke: #000;
            stroke-width: 1.5;
            transform: translate3d(0, 0, 0);
            transition: all 0.2s ease;

            path {
                stroke-dasharray: 60;
                stroke-dashoffset: 0;
            }

            polyline {
                stroke-dasharray: 22;
                stroke-dashoffset: 66;
            }
        }

        &:hover:before {
            opacity: 1;
        }

        &:hover svg {
            stroke: #333;
        }
    }

    input[type="checkbox"]:checked + .check svg,
    #ppcbx:checked + .check svg,
    [id^='formCheckbox']:checked + .check svg,
    #registered:checked + .check svg,
    #cbx2:checked + .check svg,
    #cbx3:checked + .check svg {
        stroke: #333;
    }

    #cbx4:checked + .check svg {
        stroke: #333;
    }

    #cbx5:checked + .check svg {
        stroke: #333;
    }

    input[type="checkbox"]:checked + .check svg path,
    #cbx:checked + .check svg path,
    #ppcbx:checked + .check svg path,
    [id^='formCheckbox']:checked + .check svg path,
    #registered:checked + .check svg path,
    #cbx2:checked + .check svg path,
    #cbx3:checked + .check svg path,
    #cbx4:checked + .check svg path,
    #cbx5:checked + .check svg path {
        stroke-dashoffset: 60;
        transition: all 0.3s linear;
    }

    input[type="checkbox"]:checked + .check svg polyline,
    #cbx:checked + .check svg polyline,
    #ppcbx:checked + .check svg polyline,
    [id^='formCheckbox']:checked + .check svg polyline,
    #registered:checked + .check svg polyline,
    #cbx2:checked + .check svg polyline,
    #cbx3:checked + .check svg polyline,
    #cbx4:checked + .check svg polyline,
    #cbx5:checked + .check svg polyline {
        stroke-dashoffset: 42;
        transition: all 0.2s linear;
        transition-delay: 0.15s;
    }

    .pipingColorGroup {
        .textCheckbox {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
        }

        .buttonsWrapper {
            padding: 3px;

            .inner {
                padding-bottom: 70%;
                background: url(../)
            }
        }

        .colorsWrapper {
            /* width: 85%; */
            margin: auto;
            position: relative;

            &.disabled {
                opacity: 0.2;

                &:after {
                    content: '';
                    position: absolute;
                    height: 100%;
                    width: 100%;
                    top: 0;
                    left: 0;
                    transition: all 0.1s ease-in-out;
                }
            }
        }
    }

    .hintWindow {
        position: absolute;
        width: 300px;
        top: 70px;
        /* left: calc(20% + 20px); */
        left: min(25%, 380px);
        z-index: 100;
        padding: 10px 20px 15px;
        margin-left: 15px;
        font-size: 10px;
        line-height: 1.2;
        text-align: left;
        font-weight: 300;
        opacity: 1;
        pointer-events: all;
        color: #fff;
        cursor: pointer;
        max-width: 90vw;

        @media (min-width: 1000px) {
            font-size: 13px;
            /* left: calc(min(25%,380px)); */
        }

        &:before {
            content: '×';
            position: absolute;
            font-size: 34px;
            right: 6px;
            top: 4px;
            font-weight: 100;
            line-height: 18px;
        }

        &.closed {
            opacity: 0;
            pointer-events: none;
        }

        &.grey {
            background: rgba(138, 121, 93, 0.85);
            background: rgb(169 211 227 / 85%);
            color: #000;
        }

        &.blue {
            background: rgba(138, 121, 93, 0.85);
            background: rgb(169 211 227 / 85%);
            color: #000;
        }
    }

    .progressTabs,
    .buttonsBlock {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 50%;
        top: 80%;

        .button {
            user-select: none;
            /* border-bottom:0; */
            /* cursor: pointer; */
            /* background-color: #77674A; */
            /* color: #fff; */
            /* height: 35px; */
            /* width: 100px; */
            /* line-height: 35px; */
            /* font-size: 15px; */
            /* i {
                border-color: #fff;
              } */
            /* &:hover {
                opacity: 0.8;
              } */
        }
    }

    .button-price {
        position: absolute;
        font-size: 14px;
        line-height: 18px;
        /* bottom: calc(100% + 2px); */
        top: 0;
        text-align: center;
        left: 0;
        width: 100%;
        @media screen and (max-width: 772px) {
            bottom: calc(100% + 2px);
            top: unset;
        }
    }

    .progressTabs {
        top: 0;
        z-index: 100;
        height: fit-content;
        min-height: 20px;
        margin: 20px 0;
        font-weight: 700;
        padding: 10px 20px;
        background-color: #fff;
        border: 1px solid #848484;

        box-shadow: 0px 4px 36px rgba(0, 0, 0, 0.1);
        justify-content: space-around;

        .tab {
            pointer-events: all;
            cursor: pointer;
            font-size: 12px;
            line-height: 20px;
            position: relative;
            font-weight: 300;

            &:after {
                content: '';
                width: 0%;
                position: absolute;
                bottom: -5px;
                left: 50%;
                transform: translateX(-50%);
                height: 3px;
                background-color: #b99777;
                z-index: 100;
                transition: width 0.3s ease-in-out;
            }

            &.active {
                font-weight: 700;

                &:after {
                    width: 120%;
                }
            }
        }

        .split {
            margin: 0 10px;
            width: 1px;
            height: auto;
            background-color: #848484;
        }
    }

    .centalPanel {
        width: 100%;
    }

    .panel {
        width: min(25%, 380px);
        flex-shrink: 0;
        box-sizing: border-box;
        padding: 10px 20px;
        opacity: 1;
        transform: translateX(0);
        border-left: 1px solid #d6d6d7;
        border-right: 1px solid #d6d6d7;
        overflow: auto;
        background-color: rgba(239, 239, 239, 0.6);
        z-index: 1;
        transition: opacity 0.7s 0.4s, transform 0.5s 0.4s, visibility 0.1s 0.5s ease-in-out;
        visibility: visible;
        /* max-height: 90vh; */
        /* max-height: calc(100vh - 54px); */
        max-height: 100vh;
        max-height: 100vh;

        &.hidden {
            visibility: hidden;
            pointer-events: none;
            opacity: 0;

            &.rightPanel {
                transform: translate(50px, 0);
            }

            &.leftPanel {
                transform: translate(-50px, 0);
            }
        }

        &.maxWidth {
            width: 100%;
            height: 100%;
        }

        .horizontalSplit {
            width: 100%;
            height: 1px;
            background-color: #cdccce;
            margin: 10px 0;
        }

        .group {
            position: relative;
            transition: height 0.2s 0.2s ease-in-out;
            margin-top: 10px;

            &:after {
                content: '';
                pointer-events: none;
                position: absolute;
                height: 100%;
                width: 100%;
                top: 0;
                left: 0;
                background-color: rgba(239, 239, 239, 0);
                transition: all 0.1s ease-in-out;
            }

            &.disabled {
                height: 0;
                overflow: hidden;

                &:after {
                    background-color: rgba(239, 239, 239, 0.8);
                }
            }

            &.armrestGroup .scrollWrapper .button { 
              padding-top: 14px;
            }
            &.armrestGroup .scrollWrapper .button .image {
                padding-bottom: 50%;
                @media (max-width: 768px) {
                    padding-bottom: calc(100% - 6px);
                }
            }

            &.backrestGroup .scrollWrapper .button {
                margin-left: 5px;
                margin-right: 5px;
                padding-top: 14px;
            }

            &.backrestGroup .scrollWrapper {
                justify-content: flex-start;
                width: calc(100% + 10px);
            }

            &.backrestGroup .scrollWrapper .button {
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                // background: #fff;
                align-items: center;
                border: 2px solid #D7D7D7;
                width: calc(33% - 10px);


                margin-top: 10px;
                margin-right: 10px;
                margin-left: 0;

                &.active {
                    border: 2px solid #8A795D;
                }

                .image {
                    position: static;
                    order: 1;
                    margin: 3px;
                    width: calc(100% - 6px);
                    padding-bottom: 50%;
                    transform: none;
                    background-position: center;
                    object-fit: contain;
                    @media (max-width: 768px) {
                        padding-bottom: calc(100% - 6px);
                    }
                }

                @media (max-width: 768px) {
                    .name.backrestName {
                        display: block;
                        position: absolute;
                        text-align: center;
                        width: 100%;

                        transform: none;
                        left: 0;
                        right: 0;

                        top: calc(100% + 2px);
                    }
                }

            }

            
            &.armrestGroup .scrollWrapper .button {
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                align-items: center;

            }
            &.armrestGroup .scrollWrapper .button, &.backrestGroup .scrollWrapper .button {
                display: flex;
                align-items: center;
                align-content: center;
                @media screen and (min-width: 773px) {
                    padding-top: 1rem;
                }
            }

            .title {
                padding: 10px 0;
                display: block;
                font-weight: 700;

                text-align: left;
            }

            .subtitle {
                padding: 0px 0 10px;
                display: block;
                font-weight: 400;
                font-size: 12px;

                text-align: left;
            }

            .scrollWrapper {
                display: flex;
                flex-flow: row wrap;
                justify-content: space-between;

                &.center {
                    justify-content: center;
                }

                .button {
                    width: 29%;
                    /* padding-bottom: 29%;
                    height: 0; */
                    /* height: 5vh; */
                    /* max-height: 80px; */
                    /* min-height: 20px; */
                    position: relative;
                    margin-bottom: 18px;
                    border: 2px solid #d6d6d7;
                    cursor: pointer;
                    border-radius: 2px;

                    svg{
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%) scale(0.8);
                      color: #fff;
                      opacity: 0;
                      transition: all 0.2s ease-in-out;
                    }

                    &.active {
                        border-color: #a6906e;

                        svg{
                          opacity: 1;
                          transform: translate(-50%, -50%) scale(1);
                        }
                    }

                    .image {
                        position: static;
                        margin: 3px;
                        width: calc(100% - 6px);
                        padding-bottom: 33%;
                        background-size: contain;
                        background-repeat: no-repeat;
                        background-position: center;
                        @media (max-width: 768px) {
                            padding-bottom: calc(100% - 6px);
                        }
                    }
                    .mostPopularBadge {
                        position: absolute;
                        font-weight: bold;
                        font-size: 0.75rem;
                        top: 2%;
                        width: fit-content;
                        margin-left: auto;
                        margin-right: auto;
                        padding: 0 4px;
                        background-color: #000;
                        color: #fff;
                        text-wrap: nowrap;
                     
                        @media screen and (max-width: 1050px) {
                            text-wrap: wrap;
                            top: -25%;
                        }
                        @media screen and (max-width: 773px) {
                            top: -40%;
                        }
                    }
                    .name {
                        position: absolute;

                        &.woodtrimName {
                            width: max-content;
                            bottom: -15px;
                            left: 50%;
                            transform: translateX(-50%);
                        }

                        &.backrestName,
                        &.armrestName {
                            left: 3px;
                            bottom: 3px;
                        }

                        &.layoutName {
                            width: 100%;
                            top: 105%;
                            left: 50%;
                            transform: translateX(-50%);
                            /* background-color: rgba(239, 239, 239, 0.7); */
                        }
                    }
                }
            }
        }

        .woodtrimGroup {
            .scrollWrapper {
                &::after {
                    content: '';
                    width: 49%;
                }

                .button {
                    width: calc(25% - 10px);

                    .image {
                        position: static;
                        background-size: cover;
                        height: auto;
                        margin: 3px;
                        width: calc(100% - 6px);
                        padding-bottom: 50%;
                        @media (max-width: 768px) {
                            padding-bottom: calc(100% - 6px);
                        }
                    }
                }
            }
        }

        .woodFinishGroup {
            .scrollWrapper {
                justify-content: space-around;

                .button {
                    width: 19%;
                    padding-bottom: 19%;
                    height: 0;
                    min-height: 0;
                    background-color: #d9d9d9;
                    border: none !important;
                    position: relative;
                    background-size: 131%;
                    background-repeat: no-repeat;
                    background-position: center;
                    border-radius: 100%;
                    opacity: 0.8;
                }
            }
        }

        .woodFinishGroup,
        .pinGroup {
            .scrollWrapper {
                .button {
                    &.active {
                        opacity: 1;

                        .name {
                            /* color: #fff; */
                            font-weight: 900;

                            &:after {
                                content: '';
                                width: 100%;
                            }
                        }
                    }

                    .image {
                        padding-bottom: 40%;
                    }

                    .name {
                        /* line-height: 20px; */
                        text-align: center;
                        /* width: 100%; */

                        &:after {
                            content: '';
                            position: absolute;
                            height: 2px;
                            transition: width 0.2s ease-in-out;
                            background-color: #b99777;
                            width: 0%;
                            top: 12px;
                            left: 50%;
                            transform: translate(-50%);
                            display: block;
                        }
                    }
                }
            }
        }

        .pinGroup {
            .scrollWrapper {
                &::after {
                    content: '';
                    width: 30%;
                }

                .button {
                    opacity: 0.8;
                    border: none !important;
                }
            }
        }

        .diamondGroup,
        .pipingGroup {
            .title {
                cursor: pointer;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                min-height: 40px;
                text-align: left;
                /* white-space: nowrap; */
                font-size: 16px;

                label {
                    padding-right: 5px;
                }
            }

            .buttonsWrapper {
                cursor: pointer;
                padding: 3px;
                border: 2px solid #d6d6d7;

                &.active {
                    border-color: #a6906e;
                }

                .inner {
                    width: 100%;
                    padding-bottom: 70%;
                    /* height: 250px; */
                    background-image: url(${require('../../img/diamondQuilting.png')});
                    background-size: cover;
                    background-position: center top;
                    background-repeat: no-repeat;
                    // border-radius: 5px;
                }
            }
        }

        .checkboxesGroup > .diamondGroup {
            margin-bottom: 20px;
            width: 100%;
            .buttonsWrapper {
              width: 50%;
            }
        }

        .longueGroup {
            width: 100%;
            margin-bottom: 20px;

            .buttonsWrapper {
                width: 67%;
            }

            @media (max-width: 1000px) {
                .buttonsWrapper {
                    width: 50%;
                }
            }

            .title {
                cursor: pointer;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                min-height: 40px;
                text-align: left;
                /* white-space: nowrap; */
                font-size: 16px;

                label {
                    padding-right: 5px;
                }

                .regular {
                    font-weight: normal;
                    display: inline-block;
                    margin-top: 0.3em;
                }
            }

            .buttonsWrapper {
                cursor: pointer;
                padding: 3px 15px;
                border: 2px solid #d6d6d7;
                margin-top: 15px;

                &.active {
                    border-color: #a6906e;
                }

                .inner {
                    width: 100%;
                    padding-bottom: 79%;
                    background-size: cover;
                    background-position: center top;
                    background-repeat: no-repeat;

                    margin-top: -5%;
                    margin-bottom: -5%;
                }
            }
        }

        .leatherColorsGroup {
            position: relative;

            .leatherSampleImg {
                height: 30px;
                width: 30px;
                border-radius: 100%;
                position: absolute;
                left: 10px;
                top: 5px;
                background-size: 200%;
                background-repeat: no-repeat;
            }

            .title {
                text-align: left;
                padding-left: 0px;
                padding-top: 3px;
                padding-bottom: 10px;
            }

            .title-row {
                flex-wrap: wrap;
                display: flex;
                flex-direction: row;

                .title-price {
                    font-weight: bold;
                    /* margin-left: auto; */
                    padding: 5px 0 10px 0;
                    font-size: 16px;
                    @media (max-width: 1329px) {
                        width: 100%;
                        text-align: left;
                        margin-top: -1em;
                    }
                }
            }

            .scrollWrapper {
                justify-content: flex-start;
                margin-right: -10px;
                width: calc(100% + 10px);

                /* &::after {
                  content: '';
                  width: 49%;
                } */

                .button {
                    /* width: calc(25% - 10px); */
                    width: calc(16.6% - 10px);

                    margin-right: 10px;
                    margin-bottom: 10px;
                    padding-bottom: 0;
                    box-sizing: border-box;
                    /* max-width: 60px; */
                    /* padding-bottom: 21%; */
                    height: auto;
                    max-height: none;
                    min-height: 0;
                    background: #fff;

                    .name {
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        color: #fff;
                        opacity: 1;
                    }

                    .image {
                        position: static;
                        background-size: cover;
                        width: auto;
                        height: auto;
                        /* height: 84%; */
                        /* width: 84%; */
                        /* top: 8%; */
                        /* left: 8%; */
                        display: block;
                        margin: 1px;
                        padding-bottom: 50%;

                        svg{
                          transform: translate(-50%,-50%) scale(0.6);
                        }
                    }
                }
            }

            .tooltipTrigger {
                display: inline-block;
                margin: 0 10px;
                color: #8a795c;
                font-size: 16px;
                cursor: pointer;
                /* position: absolute; */

                &:hover {
                    color: #333;
                }
            }
        }

        .stitchColorsGroup {
            .textCheckbox {
                display: flex;
                flex-direction: row;
                justify-content: center;
                margin-bottom: -5px;
            }

            .disabled {
                opacity: 0.2;
                position: relative;

                &:after {
                    content: '';
                    position: absolute;
                    height: 100%;
                    width: 100%;
                    top: 0;
                    left: 0;
                    transition: all 0.1s ease-in-out;
                }
            }

            .textNote {
                display: block;
                margin-bottom: 10px;
                margin-top: 3px;
                text-align: left;

                font-style: normal;
                font-weight: 300;
                font-size: 13px;

                color: #000000;

            }

            .scrollWrapper {
                &::after {
                    content: '';
                    width: 32%;
                }

                .stitchButton {
                    height: 25px;
                    width: 27%;
                    position: relative;
                    border: none;
                    padding: 0;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    margin-left: 5px;
                    margin-right: 5px;

                    .stitchColor {
                        position: absolute;
                        top: 0;
                        left: 50%;
                        transform: translateX(-50%);
                        font-weight: 700;

                        &:after {
                            content: '';
                            position: absolute;
                            height: 2px;
                            transition: width 0.2s ease-in-out;
                            background-color: #b99777;
                            width: 0%;
                            top: 12px;
                            left: 50%;
                            transform: translate(-50%);
                            display: block;
                        }
                    }

                    .stitchImage {
                        height: 3px;
                        width: 100%;
                        background-size: cover;
                        background-repeat: no-repeat;
                        background-position: center;
                    }

                    &.active {
                        .stitchColor {
                            font-weight: 900;

                            &:after {
                                content: '';
                                width: 100%;
                            }
                        }
                    }
                }
            }
        }

        .cupholdersGroup {
            .scrollWrapper {
                .cupholderButton {
                    --height: 40px;
                    @media (min-width: 1024px) {
                        --height: 50px;
                    }
                    width: 45%;
                    /* padding-bottom: 30%; */
                    position: relative;
                    border: none;
                    margin-bottom: 10px;

                    /* new */
                    height: var(--height) !important;
                    width: 45%;
                    padding: 3px;
                    padding-left: 5px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    /* margin-bottom: 25px; */
                    border: 1px solid #D7D7D7;

                    background: #fff;

                    .cupholderFinish {
                        position: relative;
                        margin: 0;
                        display: inline-block;
                        font-weight: normal;
                        text-align: left;
                        /* &:after {
                          content: '';
                          position: absolute;
                          height: 2px;
                          transition: width 0.2s ease-in-out;
                          background-color: #b99777;
                          width: 0%;
                          top: 12px;
                          left: 50%;
                          transform: translate(-50%);
                          display: block;
                        } */
                    }

                    .cupholderImage {
                        /* margin: 0 auto; */
                        /* width: 90%; */
                        /* padding-bottom: 90%; */
                        background-size: cover;
                        background-repeat: no-repeat;
                        background-position: center;
                        /* border-radius: 5px; */

                        /* new */
                        width: var(--height);
                        /* height: 40px; */
                        height: auto;
                        aspect-ratio: 1;
                        padding: 0;
                        margin: 0;
                        border-radius: 0;
                    }

                    &.active {
                        border: 1px solid #8A795D;

                        .cupholderFinish {
                            /* font-weight: 900; */
                            /* &:after {
                              content: '';
                              width: 100%;
                            } */
                        }
                    }
                }
            }
        }

        /* .stitchColorsGroup,
        .cupholdersGroup,
        .diamondGroup {
          margin-bottom: 10px;
          .title {
            padding-bottom: 20px;
          }
        } */

        .checkboxesGroup {
            display: flex;
            flex-flow: row wrap;
            // justify-content: center;
            justify-content: flex-start;

            & > div {
                width: 50%;
                /* padding-bottom: 45%; */
            }
        }

        .pipingGroup {
            .title {
                font-weight: 700;
            }

            .buttonsWrapper {
                padding: 3px;
                width: 77%;
                box-sizing: border-box;

                .inner {
                    background-image: url(${require('../../img/piping.png')});
                    padding-bottom: 56%;
                }

            }
        }

        .secondRow {

            .buttonsWrapper {
                padding: 0;
                margin-bottom: 20px;
                width: 77%;
                box-sizing: border-box;
                padding-bottom: 0 !important;

                border: 2px solid #d6d6d7;
                @media (max-width: 1000px) {
                    width: 50%;
                }


                &.active {
                    border-color: #8A795D;
                }

                .inner {
                    background-image: url(${require('../../img/row-short.png')});
                    background-position: center;
                    background-size: cover;
                    /* background-size: no-repeat; */
                    padding-bottom: 56%;
                }

                &.longue .inner {
                    background-image: url(${require('../../img/row-long.png')});

                }

            }
        }

        .layoutsGroup {
            .scrollWrapper .button {
                width: calc(50% - 10px);
                /* padding-bottom: 50px; */
                /* height: 5vh; */
                /* max-height: 80px; */
                /* min-height: 20px; */
                margin-bottom: 50px;
                // background: #fff;

                .name {
                }
            }

            .disabled {
                opacity: 0.2;
                position: relative;

                &:after {
                    content: '';
                    position: absolute;
                    height: 100%;
                    width: 100%;
                    top: 0;
                    left: 0;
                    transition: all 0.1s ease-in-out;
                }
            }
        }
    }

    .reportContainer {
        display: flex;
        flex-direction: column;
        min-height: 100%;
        justify-content: flex-start;
        box-sizing: border-box;
        @media (min-width: 1024px) {
            padding-top: 2rem;
        }
        @media (min-width: 1300px) {
            padding-left: 2rem;
            padding-right: 2rem;
        }

        p{
          text-align: left;
          font-size: 14px;
          line-height: 16px;
          a{
            color: inherit;
          }
        }

        .report {
            .heading {
                text-align: left;

                font-style: normal;
                font-weight: 700;
                font-size: 20px;
                line-height: 1.1;
                text-transform: uppercase;
                margin-top: 1em;
                margin-bottom: 1em;


            }

            .prop {

                font-style: normal;
                font-size: 14px;
                line-height: 1.1;
                text-align: left;
                margin-bottom: 0.5em;

                width: 100%;
                display: flex;

                text-align: left;

                .propName {
                    font-weight: 700;
                    margin-right: 7px;
                    width: 50%;
                    flex-shrink: 0;
                }

                .propValue {

                }
            }
        }
    }

    .submitPanel {
        /* width: 30%; */
        z-index: 101;
        overflow: scroll;
        -webkit-overflow-scrolling: touch;

        & > *,
        input,
        textarea,
        .inputWrapper {
            -webkit-transform: translateZ(0px);
        }

        @media (min-width: 1300px) {
            padding-left: 2rem;
            padding-right: 2rem;
        }
    }

    .submitForm {
        pointer-events: all;
        text-align: left;
        @media (min-width: 1025px) {
            padding-top: 2rem;
        }

        .headerTitle {

            // font-family: 'Roboto';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 23px;
            text-transform: uppercase;

            color: #000000;
            margin-bottom: 1em;
        }

        .question {

            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 16px;
        }

        .checkbox-columns {

            display: grid;
            grid-template-columns: 1fr 1fr;
        }
    }

    .formCheckbox {
        cursor: pointer;
        display: flex;
        flex-direction: row;

        &:not(.thin) {

            .label {
                text-align: left;

                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 1.2;

                color: #000000;

                > span {
                    margin-top: 5px;
                    display: block;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 10px;
                    line-height: 1.2;

                    color: #000000;
                }
            }
        }
    }

    .formCheckbox.thin,
    .additional .formCheckbox.thin {
        margin-top: 0;

        .label {
            padding-top: 0.1em;
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 1.2;

        }
    }

    .button.submitButton .button {

        background: #BB9776;
        border-color: #BB9776;
        border-radius: 0px;
        text-transform: uppercase;

        font-weight: 700;
        font-size: 13px;

    }

    .additional {
        .question {
            text-align: left;
            margin-bottom: 10px;
        }

        .formCheckbox {
            margin: 15px 0;
        }
    }
}

.textNote {
    text-align: left;
    font-size: 12px;
    font-weight: 300;
    margin-bottom: 10px;
}

.textCheckbox {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    line-height: 10px;
    cursor: pointer;
}

@keyframes logo-breath {
    0%,
    to {
        -webkit-transform: scale(0.86);
        transform: scale(0.86);
    }

    50% {
        -webkit-transform: scale(1.06);
        transform: scale(1.06);
    }
}

@media only screen and (min-width: 773px) {
    &.step1 {
        .back {
            visibility: hidden;
        }
    }

    &.step4 {
        .next {
            visibility: hidden;
        }
    }
}

@media only screen and (min-width: 1025px) {
    .panel {
        .title {
            font-size: 14px;
        }

        .woodtrimGroup {
            .scrollWrapper .button {
                margin-bottom: 28px;
            }
        }

        .buttonsWrapper {
            .button {
                .name {
                    font-size: 11px;

                    &.woodtrimName {
                        font-size: 11px;
                        line-height: 1;
                        height: 40px;
                        margin-bottom: -29px;
                    }
                }
            }
        }

        .leatherColorsGroup {
            .title {
                font-size: 16px;
            }

            .button {

                .name {
                    font-size: 9px;
                }
            }
        }
    }
}

@media only screen and (min-width: 773px) and (max-width: 1024px) {
    .progressTabs .tab {
        font-size: 10px;
        margin: auto;
    }

    .panel {
        .title {
            font-size: 10px;
        }

        .layoutsGroup {
            .scrollWrapper .button {
                margin-bottom: 30px;
            }
        }

        .buttonsWrapper {
            .button {
                .name {
                    font-size: 7px;
                }
            }
        }

        .leatherColorsGroup {
            .title {
                font-size: 10px;
            }

            .leatherSampleImg {
                height: 25px;
                width: 25px;
            }

            .button {
                .name {
                    font-size: 6px;
                }
            }
        }

        .cupholdersGroup {
            .buttonsWrapper {
                .scrollWrapper {
                    .button {
                        /* height: 0; */
                    }
                }
            }
        }
    }
}

/* @media only screen and (max-width: 772px) {
  flex-direction: column-reverse;
  align-items: flex-end;
  .panel {
    border: 1px solid #d6d6d7;
    .title {
      font-size: 10px;
    }
    .buttonsWrapper {
      .button {
        .name {
          font-size: 7px;
        }
      }
    }
    .leatherColorsGroup {
      .title {
        font-size: 10px;
      }
      .leatherSampleImg {
        height: 25px;
        width: 25px;
      }
      .button {
        .name {
          font-size: 6px;
        }
      }
    }
  }
} */

@media only screen and (max-width: 772px) {
    position: fixed;
    transform: translate3d(0, 0, 0);
    .hintWindow {
        top: 70px;
        left: 0;
        box-sizing: border-box;
    }

    .rightPanelContainer.panelContainer {
        display: flex;
        flex-direction: column;
    }

    .button.submitButton {
        bottom: 0px;
        width: 100%;
        /* position: fixed; */
        display: block;
        transform: translate3d(0, 0, 0);
        z-index: 100;
        margin-top: 25px;

        .button {
            box-sizing: border-box;
            width: 100%;
        }
    }

    .submitForm {
        .question {
            font-size: 12px;
        }

        form {
            padding-bottom: 50px;
        }
    }

    .buttonsBlock {
        top: calc(50% - 40px);
        bottom: auto;
        width: 100%;
        position: absolute;
        left: 0;
        transform: translate3d(0, 0, 0);
        z-index: 100;

        &.step-4 {
            display: none;
        }

        .button {
            box-sizing: border-box;
            width: 100%;

            &.resize {
                font-size: 23px;
                width: 30%;
            }
        }
    }

    .contentWrapper {
        position: fixed;
        transform: translate3d(0, 0, 0);
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        flex-direction: column;
        /* height: calc(50% - 60px); */
        height: 50%;
        /* margin-top: -60px; */
        width: 100vw;
        /* position: relative; */
        display: block;
        align-self: flex-end;

        .panel {
            min-height: 51%;

            &:last-of-type {
                /* margin-bottom: 75px; */
            }
        }

        .progressTabs {
            display: none;
        }

        /* align-items: flex-start; */
        /* padding-bottom: 50px; */

        &:after {
            content: '';
            position: absolute;
            bottom: -1px;
            height: 1px;
            width: 100%;
            left: 0;
        }

        &.disabled {
            z-index: 100;
        }

        &:not(.disabled) {
            background-color: rgba(239, 239, 239, 1);
        }

        &:first-of-type.disabled {
            top: 0;
        }

        .panel {
            background-color: rgba(239, 239, 239, 1);
            overflow: hidden;

            &.hidden {
                transform: translate(0, 50px);
            }

            /* &.leftPanel .leatherPanel {
              flex-direction: row;
              display: flex;
            } */
            border: none;
            /* height: 25%; */
            min-height: min-content;
            width: 100%;
            padding: 0 10px;
            box-sizing: border-box;

            .group {
                /* overflow: hidden; */
            }

            .title {
                font-size: 14px;
            }

            .title-price {
                font-weight: bold;
                font-size: 14px;
                padding: 5px 0 13px 0;

            }

            .backrestGroup {
                order: -1;
            }


            .backrestGroup,
            .armrestGroup,
            .stitchColorsGroup,
            .cupholdersGroup,
            .layoutsGroup,
            .pinGroup {
                .scrollWrapper .button {
                    width: 50px;
                    height: 50px;
                    padding-bottom: 0;
                    padding-top: 0;
                    padding-right: 0;
                    margin: 2px;
                    margin-left: 5px;
                    margin-right: 5px;

                    .name {
                        font-size: 10px;
                    }
                }
            }

            .armrestGroup .scrollWrapper .button .name {
                font-size: 8px;
            }

            .cupholdersGroup {
                .buttonsWrapper {
                    /* height: 30vw; */
                    padding-bottom: 10px;

                    .scrollWrapper {
                        /* justify-content: space-around; */
                        justify-content: flex-start;

                        .button {
                            /* height: 25vw; */
                            min-width: 30%;
                        }
                    }
                }
            }

            .pinGroup {
                .scrollWrapper .button {
                    width: 13vw;
                }
            }

            .stitchColorsGroup {
                .scrollWrapper .button {
                    height: 8vw;
                }
            }

            .layoutsGroup {
                height: auto;
                // min-height: 160px;

                .buttonsWrapper {
                    /* overflow: hidden; */
                    height: 100%;
                    /* width: 98vw; */

                    .scrollWrapper {
                        /* width: calc(16 * 20vw); */
                        height: 100%;
                        /* min-height: calc(100% + 1px); */

                        .button {
                            height: auto;
                            width: 27vw;
                            margin-bottom: 32px;

                            .image {
                                padding-bottom: 40%;
                                position: static;
                                height: auto;
                                width: 100%;
                            }

                            /* margin-bottom: 10vw; */
                        }
                    }
                }
            }

            .woodFinishGroup .scrollWrapper .button {
                width: 50px;
                height: 50px;
                padding-bottom: 0;
                margin-bottom: 20px;
                // transform: scale(0.9);
                background-color: transparent;
                background-size: 90%;
                background-position: center;

            }

            .woodtrimGroup .scrollWrapper .button,
            .leatherColorsGroup .scrollWrapper .button,
            .woodFinishGroup .scrollWrapper .button {
                width: 50px;
                height: 50px;
                padding-bottom: 0;
                margin: 2px;
                max-height: unset;

                flex-shrink: 0;

                // background: #fff;

                .name {
                    font-size: 8px;
                }
            }

            .leatherColorsGroup .scrollWrapper .button {
                // height: auto;

                .image {
                    padding-bottom: calc(100% - 2px);
                }

                .leatherColorName {
                    display: none;
                }
            }

            .woodFinishGroup .scrollWrapper .button {
                width: 50px;
                height: 50px;
            }

            .checkboxesGroup {
                justify-content: flex-start;

                > div {
                    width: 40%;
                }

                .diamondGroup,
                .pipingGroup {
                    padding-bottom: 10px;

                    .title {
                        min-height: 0;
                    }

                    .buttonsWrapper {
                        padding: 3px;
                    }
                }
            }
            .checkboxesGroup > .diamondGroup {
                width: 100%;
                .buttonsWrapper {
                  width: 60%;
                }
            }

            .buttonsWrapper {
                overflow: auto;
                overflow-y: hidden;
                -webkit-overflow-scrolling: touch;
                padding-bottom: 15px;
                padding-top: 15px;

                .scrollWrapper {
                    flex-wrap: nowrap;
                    min-width: max-content;
                    justify-content: flex-start;
                    -webkit-overflow-scrolling: auto;

                    &::after {
                        content: none;
                    }
                }
            }

            .leatherColorsGroup {
                /* width: 100%; */
                /* min-width: min-content; */

                .title {
                    font-size: 16px;
                    padding-top: 3px;
                    padding-bottom: 10px;
                }

                .title-row {
                    flex-wrap: wrap;
                    display: flex;
                    flex-direction: row;

                    .title-price {
                        margin-left: auto;
                        font-size: 16px;
                    }

                    .font-weight {
                        font-size: 16px;
                    }
                }

                .button {
                    .name {
                        font-size: 9px;
                    }
                }
            }

            .pipingColorGroup {
                .colorsWrapper {
                    width: 100%;
                    display: flex;
                    overflow: auto;
                }
            }
        }
    }


    .mobileReport {
        z-index: 100;
        height: 45%;
        height: calc(50% - 40px);
        height: 100%;
        display: none;

        &.step-4 {
            background-color: rgba(239, 239, 239, .61);
            display: block;
        }

        .panel {
            width: 100vw;
            box-sizing: border-box;
            height: 100%;

            &:not(.disabled) {
                pointer-events: all;
            }

            .reportContainer {

                top: 0;
                left: 0;

                .button {
                    margin-bottom: 10px;
                }

                .report {
                    .heading {
                        text-align: left;

                        font-style: normal;
                        font-weight: 700;
                        font-size: 20px;
                        line-height: 1.1;
                        text-transform: uppercase;

                        color: #000000;

                    }

                    .prop {
                        text-align: left;
                        font-size: 12px;
                        margin: 5px 0;
                        width: 100%;
                        text-align: left;

                        .propName {
                            display: inline-block;
                            font-weight: 700;
                            margin-right: 5px;
                            text-align: left;
                        }

                        .propValue {
                            display: inline-block;
                            text-align: left;
                        }
                    }
                }
            }
        }
    }

    .progressTabs {
        display: none;
    }

    &.step1 {
        .back {
            /* display: none; */
            pointer-events: none;

            a,
            i {
                color: transparent !important;
                border: transparent !important;
            }
        }
    }

    &.step4 {
        .next {
            /* display: none; */
            pointer-events: none;

            a,
            i {
                color: transparent !important;
                border: transparent !important;
            }
        }

        .contentWrapper {
            /* overflow: hidden; */
            display: none;
        }

        .submitPanel {
            height: 100%;
            overflow: visible;
            /* max-height: 100%; */

        }
    }

    .button {
        margin: 0;
    }

    &.extendedRatio {
        .mainFrame iframe {
            height: calc(70% - 55px);
            margin-top: 55px;
        }

        .buttonsBlock {
            top: calc(70% - 40px);
            bottom: auto;
        }

        .contentWrapper {
            height: 30%;
            /* margin-top: -60px; */

            .panel {
                min-height: 31%;
            }
        }

        .mobileReport {
            height: calc(70% - 40px);
            height: 100%;
        }
    }
}
`

export const ExportTool = styled.div`
  overflow: auto;
  max-height: 70vh;
  margin-top: 20px;
  .wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  .inputs {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-end;
    & > * {
      margin: 0 10px;
      .button {
        margin: 10px 0 0 0;
      }
    }
  }
  .label {
    text-align: left;
    font-size: 16px;
    font-weight: 300;
    margin: 5px 0;
  }
  .text {
    text-align: left;
    user-select: all;
    margin: 0 0 20px auto;
    width: 350px;
    max-width: 65vw;
    padding: 10px;
    border: 2px solid #b99777;
    .prop {
      font-size: 18px;
      /* width: 100%; */
      .propName {
        display: inline-block;
        font-weight: 700;
        margin-right: 5px;
      }
      .propValue {
        display: inline-block;
      }
    }
  }
  .screenshots {
    height: 320px;
    & > * {
      width: 300px;
    }
  }

`

export default ExportTool
